import fircroft1 from '../images/logos/fircroftb.png'
import fircroft2 from '../images/logos/fircroftwg.png'
import fircroft3 from '../images/logos/fircroftp.png'
import mich1 from '../images/logos/michw.png'
import mich2 from '../images/logos/michwb.png'
import mich3 from '../images/logos/michwo.png'
import rx1 from '../images/logos/rx1.png'
import rx2 from '../images/logos/rx2.png'
import rx3 from '../images/logos/rx3.png'
import qr1 from '../images/logos/qrbrd.png'
import qr2 from '../images/logos/qrww.png'
import be2541 from '../images/logos/be254w.png'
import be2542 from '../images/logos/be254y.png'
import ex1 from '../images/logos/exbbb.png'
import ex2 from '../images/logos/exwr.png'
import multibal1 from '../images/logos/multibal1.png'
import multibal2 from '../images/logos/multibal2.png'
import anetquick1 from '../images/logos/aq.png'

export const designProjects = [
    {
      title: "Fircroft",
      images: [fircroft1, fircroft2, fircroft3],
    },
    {
      title: "Brian Michira",
      images: [mich1, mich2, mich3],
    },
    {
      title: "QR Management",
      images: [qr2, qr1],
    },
    {
      title: "RumaX Consultants",
      images: [rx3, rx2, rx1],
    },
    {
      title: "BE254",
      images: [be2541, be2542],
    },
    {
      title: "EX Management",
      images: [ex1, ex2],
    },
    {
      title: "Multiball",
      images: [multibal1, multibal2],
    },
    {
      title: "Anetquick Solutions",
      images: [anetquick1],
    },
]